export default "__VITE_ASSET__CWSUZwbl__"